import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent, SnackbarStatus } from '@app/shared/components/snackbar/snackbar.component';

/** App-wide Material snackbar toasts. */
@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    constructor(private snackBar: MatSnackBar) {}

    /**
     * Shows a snackbar toast.
     * @param message - Text to display
     * @param status - Visual variant (success, error, warning, info)
     * @param duration - Auto-dismiss time in ms
     */
    open(message: string, status: SnackbarStatus = 'success', duration: number = 5000): void {
        this.snackBar.openFromComponent(SnackbarComponent, {
            data: { message, status },
            duration: duration,
            horizontalPosition: 'right',
            verticalPosition: 'top',
        });
    }

    /** Shows an error snackbar. */
    error(message: string): void {
        this.open(message, 'error');
    }

    /** Shows a warning snackbar. */
    warning(message: string): void {
        this.open(message, 'warning');
    }

    /** Shows a short info snackbar. */
    info(message: string): void {
        this.open(message, 'info', 2500);
    }
}
